import { render } from "./MultiItemMenuLayoutEditor.vue?vue&type=template&id=06523e94&scoped=true&ts=true"
import script from "./MultiItemMenuLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./MultiItemMenuLayoutEditor.vue?vue&type=script&lang=ts"

import "./MultiItemMenuLayoutEditor.vue?vue&type=style&index=0&id=06523e94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06523e94"]])

export default __exports__